import { z } from 'zod';

export const whatsAppConfigSchema = z.object({
  serviceId: z.string().min(1, 'Service ID is required'),
  verifyToken: z.string().min(1, 'Verify token is required'),
  accessToken: z.string().min(1, 'Access token is required'),
  phoneNumberId: z.string().min(1, 'Phone number ID is required'),
  apiUrl: z.string().url('Must be a valid URL'),
});

export type WhatsAppConfigFormData = z.infer<typeof whatsAppConfigSchema>;
